import type { SVGProps } from "react";
export interface TwitterSquareIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TwitterSquareIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TwitterSquareIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M14.364 6.884c.57.041 1.095.234 1.561.485h.82c.577 0 .994.347 1.197.709.176.313.247.728.113 1.133l-.07.173-.472.97c-.075 2.822-1.318 5.04-3.33 6.262-2.057 1.249-4.728 1.347-7.359.26a1.125 1.125 0 0 1 .281-2.155q.308-.043.548-.097c-1.391-1.793-1.778-3.807-1.778-5.783 0-1.069 1.213-1.79 2.134-1.163l.179.143.457.396c.773.627 1.537 1.01 2.41 1.173q.044-.214.114-.423c.2-.583.556-1.067 1.091-1.46l.25-.168a3.08 3.08 0 0 1 1.854-.455M14.2 9.128c-.188-.014-.382.025-.608.192-.182.134-.25.247-.296.378-.06.174-.093.436-.093.908 0 .621-.504 1.125-1.125 1.125-1.453 0-2.676-.362-3.786-1.021.254 1.258.83 2.396 1.959 3.409a1.13 1.13 0 0 1 .291 1.255c.942-.02 1.783-.262 2.472-.68 1.31-.795 2.255-2.329 2.255-4.611 0-.17.039-.338.113-.49l.002-.005a1.1 1.1 0 0 1-.347-.14c-.341-.212-.62-.304-.837-.32"
      />
    </svg>
  );
}
